import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye,faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import TableLoader from './Loader/TableLoader';

interface Item {
  id: number;
  category: string;
  title: string;
  author: string;
  status: string;
  // Add more properties as per your item structure
}

interface currentApprovalsTableProps {
  items: Item[];
  loading: boolean;
  onView: (id: number) => void;
  onApprove: (id: number) => void;
  onDecline: (id: number) => void;
}

export default function CurrentApprovalsTable({ items, loading, onView, onApprove, onDecline  }: currentApprovalsTableProps) {
  const [approvalPage, setApprovalPage] = useState(1);
  const approvalPerPage = 5;
  const pendingItems = items.filter(item => item.status === 'Pending');
  const totalPages = Math.ceil(pendingItems.length / approvalPerPage); 
  const indexOfLastApproval = approvalPage * approvalPerPage;
  const indexOfFirstApproval = indexOfLastApproval - approvalPerPage;
  const currentApprovals = pendingItems.slice(indexOfFirstApproval, indexOfLastApproval);

  const [author, setAuthor] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);

  const nextApprovalPage = () => {
    if (approvalPage < totalPages) {
      setApprovalPage(approvalPage + 1);
    }
  };

  const prevApprovalPage = () => {
    if (approvalPage > 1) {
      setApprovalPage(approvalPage - 1);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [approvalPage]);

  useEffect(() => {
    const storedAuthor = localStorage.getItem('author');
    const storedRole = localStorage.getItem('role');
    setAuthor(storedAuthor);
    setRole(storedRole);
  }, []);

  return (
    <>
      {(role === 'IT' || role === 'Magazine') && (
        <div className="flex flex-col">
          {loading ?
            (
              <TableLoader />
            )

            :

            (
              <table>
                <thead className="bg-gray-400">
                  <tr>
                    <th style={{ width: '20%' }}>Category</th>
                    <th style={{ width: '30%' }}>Title</th>
                    <th style={{ width: '20%' }}>Author</th>
                    <th style={{ width: '20%' }}>Status</th>
                    <th style={{ width: '10%' }} className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentApprovals.length !== 0 ?
                    ( 
                      currentApprovals.map(item => ( item.status === 'Pending' && (
                        <tr key={item.id}>
                          <td>{item.category}</td>
                          <td>{item.title}</td>
                          <td>{item.author}</td>
                          <td>{item.status}</td>
                          <td className="text-center">
                            <button 
                              onClick={() => onView(item.id)} 
                              // className='bg-red-600 rounded-sm text-white text-xl mr-2' 
                              data-tooltip-id='preview'>
                              <FontAwesomeIcon icon={faEye} className="text-sx text-white bg-red-600 rounded-md p-1 mr-2" />
                              {/* <BsEye /> */}
                            </button>

                            <button 
                              onClick={() => onApprove(item.id)} 
                              // className='bg-green-600 rounded-sm text-white text-xl mr-2' 
                              data-tooltip-id='Approved'>
                              <FontAwesomeIcon icon={faPenToSquare} className="text-sx text-white bg-red-600 rounded-md p-1 mr-2" />
                              {/* <BsCheck /> */}
                            </button>

                            <button 
                              onClick={() => onDecline(item.id)} 
                              // className='bg-gray-600 rounded-sm text-white text-xl' 
                              data-tooltip-id='Declined'>
                              <FontAwesomeIcon icon={faTrash} className="text-sm text-white bg-gray-600 rounded-md p-1" />
                              {/* <BsX /> */}
                            </button>
                          </td>
                        </tr>
                      )))
                    )

                    :

                    (
                      <tr>
                        <td colSpan={5} className="text-center">No data available!</td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
            )
          }

          {totalPages > 1 && (
            <div className="flex justify-center items-center mt-4 space-x-4">
              <button
                onClick={() => setApprovalPage(1)}
                className="px-3 py-1 rounded bg-gray-500 text-white disabled:opacity-50"
                disabled={approvalPage === 1}>
                First
              </button>

              <button
                onClick={() => setApprovalPage(prev => Math.max(prev - 1, 1))}
                className="px-3 py-1 rounded bg-gray-500 text-white disabled:opacity-50"
                disabled={approvalPage === 1}>
                Prev
              </button>

              {[...Array(totalPages)].map((_, index) => {
                const pageNum = index + 1;
                const inRange = Math.abs(pageNum - approvalPage) <= 1;

                if (inRange) {
                  return (
                    <button
                      key={pageNum}
                      onClick={() => setApprovalPage(pageNum)}
                      className={`px-3 py-1 rounded ${
                        approvalPage === pageNum ? 'bg-red-600 text-white' : 'bg-gray-200 text-black'
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                }

                return null;
              })}

              <button
                onClick={() => setApprovalPage(prev => Math.min(prev + 1, totalPages))}
                className="px-3 py-1 rounded bg-red-500 text-white disabled:opacity-50"
                disabled={approvalPage === totalPages}>
                Next
              </button>

              <button
                onClick={() => setApprovalPage(totalPages)}
                className="px-3 py-1 rounded bg-red-500 text-white disabled:opacity-50"
                disabled={approvalPage === totalPages}>
                Last
              </button>
            </div>
          )}
        </div>
      )}
    </>
  )
}